import { gsap } from "../global/gsap";

const initBtnHover = (buttons) => {
    const duration = 0.3;

    function getEnterDirection(e, el) {
        const rect = el.getBoundingClientRect();

        // Mouse position relative to the element's centre
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;

        // Compare the angle to determine which edge was crossed
        // atan2 gives us the angle, we compare against the element's diagonal
        const angle = Math.atan2(y * rect.width, x * rect.height);

        if (angle >= -Math.PI * 0.25 && angle < Math.PI * 0.25) return "right";
        if (angle >= Math.PI * 0.25 && angle < Math.PI * 0.75) return "bottom";
        if (angle >= -Math.PI * 0.75 && angle < -Math.PI * 0.25) return "top";
        return "left";
    }

    function getTransformOrigin(direction) {
        const origins = {
            top: 'center top',
            bottom: 'center bottom',
            left: 'left center',
            right: 'right center',
        };
        return origins[direction];
    }

    buttons.forEach((btn) => {
        const span = btn.querySelector('.js-bg');

        btn.addEventListener("mouseenter", (e) => {
            const direction = getEnterDirection(e, btn);
            const isHorizontal = direction === 'left' || direction === 'right';

            gsap.set(span, {
                transformOrigin: getTransformOrigin(direction),
                scaleX: isHorizontal ? 0 : 1,
                scaleY: isHorizontal ? 1 : 0,
            });

            gsap.to(span, {
                scaleX: 1,
                scaleY: 1,
                duration,
                ease: 'power2',
                overwrite: true,
            });
        });

        btn.addEventListener("mouseleave", (e) => {
            const direction = getEnterDirection(e, btn);
            const isHorizontal = direction === 'left' || direction === 'right';

            gsap.set(span, {
                transformOrigin: getTransformOrigin(direction),
            });

            gsap.to(span, {
                scaleX: isHorizontal ? 0 : 1,
                scaleY: isHorizontal ? 1 : 0,
                duration,
                ease: 'power2',
                overwrite: true,
            });
        });
    });
};

export { initBtnHover as default };
